// extracted by mini-css-extract-plugin
module.exports = {"foot-title":"AppFooter_foot-title_1bfS0","foot-item":"AppFooter_foot-item_2sg-k"};